import React from 'react';
import styles from './InsuranceDevice.module.css';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import * as routes from 'app/routes';

import DeviceSelector from 'devices/DeviceSelector';
import Back from 'common/Back';

const QuickInsuranceDevice = ({ subId }) => (
  <div className={styles.InsuranceDevice}>
    <SubscriptionSwitcher
      quickSubId={subId}
      quickRoute={routes.quickSubscription}
      attRoute={routes.attSubscription}
      sprintRoute={routes.sprintSubscription} 
    />
    <div className={styles.Back}>
      <Back to={routes.quickSubscription(subId)} />
    </div>
    <h1>
      Device Protection
    </h1>
    <DeviceSelector subId={subId} next={routes.quickInsurancePlan} />
  </div>
)

export default QuickInsuranceDevice;
